import { defineStore } from 'pinia'
import { useStoryBlokStore } from "./storyblok";
import { computed } from 'vue';


export const useSpaeakersStore = defineStore('speakers', () => {

  const storyBlockStore = useStoryBlokStore();

  const speakersStory = computed(() => {
    if (storyBlockStore.body === undefined) return undefined;
    return storyBlockStore.body.find(el => el.component === 'speakers');
  });

  const speakers = computed(() => {
    if (speakersStory.value === undefined) return undefined;

    return speakersStory.value.speakers;
  });

  const shown = computed(() => {
    if (speakersStory.value === undefined) return false;
    return speakersStory.value.shown;
  });

  return { speakers, shown, speakersStory }
});
